const planReducer = (state = [], action) => {
  switch (action.type) {
    case 'PLAN':
      return action.data
    default:
      return state
  }
}

export default planReducer
